import { render, staticRenderFns } from "./PostingActivityTable.vue?vue&type=template&id=9119071a&scoped=true&"
import script from "./PostingActivityTable.vue?vue&type=script&lang=js&"
export * from "./PostingActivityTable.vue?vue&type=script&lang=js&"
import style0 from "./PostingActivityTable.vue?vue&type=style&index=0&id=9119071a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9119071a",
  null
  
)

export default component.exports